import { ROUTES } from "constants/routes.constants"

export const CHILDREN_MENU_ITEMS_EXCLUDED_BY_ROUTES = {
  SHOPIFY: [ROUTES.MY_PROFILE_PASSWORD, ROUTES.PAYMENTS_BILLING],
  PRESTASHOP: null
}